import React, { useState } from "react";
import {
  Datagrid,
  DateField,
  TopToolbar,
  FunctionField,
  NumberField,
  TextField,
  List,
  useListContext,
} from "react-admin";
import {
  Box,
  Button,
  TextField as MuiTextField,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CustomPagination from "../../Components/CustomPagination";

const CustomFilter = () => {
  const { setFilters } = useListContext();
  const [filterValue, setFilterValue] = useState("");

  const handleApply = () => {
    if (!filterValue || filterValue === "") return;
    setFilters({ playerName: filterValue }, {});
  };

  const handleClear = () => {
    setFilterValue("");
    setFilters({}, {});
  };

  return (
    <Box display="flex" alignItems="center" gap={2} sx={{ mb: 2 }}>
      <MuiTextField
        size="small"
        label="Search Player Name"
        value={filterValue}
        onChange={(e) => setFilterValue(e.target.value)}
        onKeyPress={(e) => e.key === "Enter" && handleApply()}
        sx={{ minWidth: 200 }}
      />
      <Button variant="contained" onClick={handleApply}>
        Apply
      </Button>
      <Button variant="outlined" onClick={handleClear}>
        Clear
      </Button>
    </Box>
  );
};

const ListActions = () => (
  <TopToolbar>
    <CustomFilter />
  </TopToolbar>
);

// Custom Pagination Component
const PostPagination = () => {
  const { total, page, perPage, setPage, setPerPage } = useListContext();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100% !important",
        margin: "16px 0px",
      }}
    >
      <CustomPagination
        page={page}
        perPage={perPage}
        total={total}
        setPage={setPage}
        setPerPage={setPerPage}
      />
    </Box>
  );
};

export const HourlyBonusHistoryList = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box 
      sx={{
        mt: 4,
        backgroundColor: "#242424",
        borderRadius: 2,
        boxShadow: "none !important",
        padding: isSmallScreen ? { xs: 0, sm: 0 } : { xs: 1.5, sm: 2 },
      }}
    >
      <List
        {...props}
        resource="hourlyBonusHistory"
        pagination={<PostPagination />}
        actions={<ListActions />}
        sort={{ field: "transactionDate", order: "DESC" }}
        sx={{ "& .RaList-content": { boxShadow: "none" } }}
      >
        {isSmallScreen ? (
          // Mobile view - simplified
          <Datagrid 
            bulkActionButtons={false} 
            sx={{ "& .column-undefined": { display: "none" } }}
          >
            <TextField source="playerName" label="Player" />
            <FunctionField
              label="Reward"
              render={(record) => `${record.grossRewardAmount} ${record.rewardTypeText}`}
            />
            <NumberField source="netCreditedAmount" label="Amount" />
            <DateField source="transactionDate" label="Date" showTime />
          </Datagrid>
        ) : (
          // Desktop view - full table
          <Datagrid 
            bulkActionButtons={false} 
            sx={{ "& .column-undefined": { display: "none" } }}
          >
            <TextField source="transactionId" label="Transaction ID" />
            <TextField source="playerName" label="Player Name" />
            <NumberField source="grossRewardAmount" label="Gross Reward" />
            <TextField source="rewardTypeText" label="Reward Type" />
            <NumberField source="convertedVCAmount" label="Converted VC" />
            <NumberField source="netCreditedAmount" label="Net Credited" />
            <NumberField source="playerBalanceBefore" label="Player Before" />
            <NumberField source="playerBalanceAfter" label="Player After" />
            <TextField source="gameOwnerName" label="Game Owner" />
            <NumberField source="gameOwnerBalanceBefore" label="Owner Before" />
            <NumberField source="gameOwnerBalanceAfter" label="Owner After" />
            <DateField source="transactionDate" label="Transaction Date" showTime />
          </Datagrid>
        )}
      </List>
    </Box>
  );
};